/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-07-21 11:26:20
 * @FilePath: \frontend\src\store\index.js
 */

import { createStore } from 'vuex';
import getters from './getters';
import app from './modules/app';
import system from './modules/system';
import settings from './modules/settings';
import user from './modules/user';
import router from './modules/router';
import service from './modules/service';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  plugins: [
    createPersistedState({
      paths: ['user', 'service'],
      storage: {
        getItem: (key) => window.localStorage.getItem(key),
        setItem: (key, value) => window.localStorage.setItem(key, value),
        removeItem: (key) => window.localStorage.removeItem(key),
      },
    }),
  ],
  modules: {
    app,
    settings,
    system,
    user,
    service,
    router,
  },
  getters,
});

export default store;
